const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8787';

export async function sendChatMessage({ message, history, property, language, guestContext }) {
  const response = await fetch(`${API_URL}/chat`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      message,
      history,
      property,
      language,
      guestContext,
    }),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || `API error ${response.status}`);
  }

  return data;
}

export async function checkApiHealth() {
  try {
    const response = await fetch(`${API_URL}/health`);
    return response.ok;
  } catch {
    return false;
  }
}
